import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from "react-stripe-elements";

class CardSection extends Component {
  render() {
    return (
      <div>
        <div style={{ clear: "both" }} />
        <hr />
        <h3>Credit Card Details</h3>

        <Row>
          <Col sm={6}>
            <label className="cardElementWrapper">
              <CardNumberElement
                className="field"
                style={{ base: { fontSize: "15px", color: "#32315E" } }}
                hidePostalCode={true}
              />
              <span style={{ marginTop: -10 }}>
                <img src="/img/cc-list.png" width="175" />
              </span>
            </label>
          </Col>

          <Col sm={3}>
            <label className="cardElementWrapper">
              <CardExpiryElement
                className="field"
                style={{ base: { fontSize: "15px", color: "#32315E" } }}
                hidePostalCode={true}
              />
              <span style={{ fontSize: 11, marginTop: -15 }}>expiration</span>
            </label>
          </Col>
          <Col sm={3}>
            <label className="cardElementWrapper">
              <CardCVCElement
                className="field"
                style={{ base: { fontSize: "15px", color: "#32315E" } }}
                hidePostalCode={true}
              />
              <span style={{ fontSize: 11, marginTop: -15 }}>3 digit code</span>
            </label>
          </Col>
        </Row>

        <div style={{ clear: "both" }} />
      </div>
    );
  }
}

export default CardSection;
